<div class="" fxLayout="row" fxLayoutAlign="space-between start">
<h2 mat-dialog-title>{{ "USER_AGREEMENT" | translate }}</h2>
<button mat-dialog-close mat-icon-button><mat-icon>close</mat-icon></button>
</div>


<mat-dialog-content class="user-agreement">


  <div class=WordSection1>

    <p class=MsoNormal align=center style='margin-top:0in;margin-right:0in;
    margin-bottom:12.0pt;margin-left:0in;text-align:center;line-height:15.0pt'><b><span
    lang=DE style='font-family:"Times New Roman",serif;color:#343434'>Allgemeine
    Geschäftsbedingungen (nachfolgend „AGB“) der DPI Deutsche Premium Investment
    GmbH „DPI“ fü</span></b><b><span lang=DA style='font-family:"Times New Roman",serif;
    color:#343434'>r Goldsparpl</span></b><b><span lang=DE style='font-family:"Times New Roman",serif;
    color:#343434'>äne</span></b></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>&nbsp;</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>Die
    DPI Deutsche Premium Investment GmbH, Paffrather Str. 315, 51469 Bergisch
    Gladbach, Deutschland, eingetragen im Handelsregister des Amtsgerichts K</span><span
    lang=SV style='font-family:"Times New Roman",serif;color:#343434'>öln</span><span
    lang=DE style='font-family:"Times New Roman",serif;color:#343434'> unter HRB
    107093 nachfolgend „Anbieter“ genannt, ist ein Unternehmen, welches
    Verbrauchern und Unternehmen, nachfolgend „Kunde“ genannt, den Ankauf und
    Verkauf von Edelmetallen sowohl über die Internetplattform dpigold.com als auch
    über die App  DPI Gold ermöglicht. </span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'><br>
    </span><b><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>§
    1 Geltungsbereich, Allgemeines   </span></b></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'><br>
    </span><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(1)
    Für die Geschäftsbeziehung zwischen der Deutsche Premium Investment „DPI“, als
    eingetragener Inhaber der Marke „Deutsche Premium Investment“ und dem Kunden
    zum kontinuierlichen Erwerb und Aufbau von Physischen Goldbeständen in
    Miteigentümer-Sammelverwahrung gelten ausschließlich die nachfolgenden
    Allgemeinen Geschäftsbedingungen in Ihrer zum Zeitpunkt der Bestellung gültigen
    Fassung. </span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>Abweichende
    Bedingungen des Kunden werden nicht anerkannt, es sei denn, die Deutsche
    Premium Investment stimmt ihrer Geltung ausdrücklich schriftlich zu. </span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>Soweit
    sich aus den Bedingungen nichts anderes ergibt, gelten ergänzend die
    gesetzlichen Vorschriften. </span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(2)
    Verbraucher ist jede natürliche Person, die ein Rechtsgeschäft zu Zwecken
    abschließt, die überwiegend weder ihrer gewerblichen noch ihrer selbstständigen
    beruflichen Tätigkeit zugrechnet werden kann.  </span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>Unternehmer
    ist jede natürliche und juristische Person oder rechtsfähige
    Personengesellschaft, die beim Abschluss des Vertrages in Ausübung ihrer
    gewerblichen oder selbstständigen beruflichen Tätigkeit handelt. </span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'><br>
    </span><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(3)
    Die Geschäftstätigkeit und insbesondere das Internet-Angebot des Anbieters
    richtet sich, vorbehaltlich abweichender Vereinbarung im Einzelfall, ausschließlich
    an Kunden, die ihren gew</span><span lang=SV style='font-family:"Times New Roman",serif;
    color:#343434'>ö</span><span lang=DE style='font-family:"Times New Roman",serif;
    color:#343434'>hnlichen Aufenthalt (Rechnungsadresse) in Deutschland haben.</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(4)
    Änderungen der gültigen AGB unter Einhaltung der gesetzlichen Vorschriften
    werden auf der Internetseite des Anbieters (www.) publiziert und erlangen somit
    Gu</span><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>̈</span><span
    lang=DE style='font-family:"Times New Roman",serif;color:#343434'>ltigkeit. Für
    die Gültigkeit ist eine Zustellung und Information an den Kunden nicht
    erforderlich. </span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(5)
    Änderungen der gültigen Sparplanbedingungen unter Einhaltung der gesetzlichen
    Vorschriften werden dem Kunden in Textform mitgeteilt. </span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>Die
    Änderungen werden wirksam, wenn der Kunde diesen zugestimmt hat oder nach
    schriftlicher Mitteilung durch den Anbieter nicht innerhalb von 4 Wochen ab
    Zugang der Mitteilung widersprochen hat. Die Kündigungsrechte beider Parteien
    bleiben unberührt. </span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(6)
    Für sämtliche rechtserhebliche Erklärungen und Verfügungen in Bezug auf alle
    mit dem Anbieter geschlossenen Verträge in Bezug Auf Edelmetallankauf und
    Sparplan gilt die Schriftform. </span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(7)
    Bei Mitteilung einer E-Mail-Adresse durch den Kunden erklärt sich der Kunde
    damit einverstanden, dass zum Zwecke des Vertragsabschlusses und zur Abwicklung
    der Geschäftsbeziehung eine elektronische Kommunikation erfolgt. Der Kunde kann
    jederzeit durch schriftliche Mitteilung die Zustimmung zur elektronischen
    Kommunikation widerrufen. In diesem Fall erfolgt die geschäftliche
    Kommunikation über den Postweg. </span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><b><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>§
    2 Verkauf von Waren durch den Anbieter</span></b></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(1)
    Der Kunde kann aus dem Sortiment des Anbieters Waren, insbesondere Edelmetalle,
    auswählen und diese über den Button „kaufen“ in einem Warenkorb sammeln. Da die
    Preise der Waren Kursschwankungen unterliegen und auch nur bestimmte
    Warenkontingente vorhanden sind, bleibt der Inhalt des Warenkorbs nur für einen
    bestimmten Zeitraum bestehen. Der Kunde kann sich ferner entweder für den
    Versand der Waren (wenn diese Möglichkeit auf der Plattform angeboten wird)
    oder aber für die Verwahrung bei einem geprüften Logistik- und Lagerungspartner
    des Anbieters durch Anklicken der entsprechenden Option entscheiden.
    Entscheidet sich der Kunde für die Verwahrung, so muss sich der Kunde
    registrieren und unter anderem ein Referenzkonto angeben. Mit der Registrierung
    erhält der Kunde ein Kundenkonto.</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>Über
    den Button „Jetzt kaufen“ gibt der Kunde einen verbindlichen Antrag zum Kauf
    der im Warenkorb befindlichen Waren und - falls diese Option gewählt worden ist
    - zur Verwahrung der Waren ab. Die Verwahrung ist ein vom Kauf zu
    unterscheidendes, separates Rechtsgeschäft. Vor Abschicken der Bestellung kann
    der Kunde die Daten jederzeit ändern und einsehen. Der Antrag kann jedoch nur
    abgegeben und übermittelt werden, wenn der Kunde durch Klicken auf den Button „AGB
    und Datenschutzerklärung akzeptieren“ diese Vertragsbedingungen anerkennt und
    dadurch in seinen Antrag aufgenommen hat.</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(2)
    Der Anbieter speichert den Vertragstext und schickt nach Abschicken der
    Bestellung dem Kunden eine automatische Auftragsbestätigung per E-Mail zu, in
    welcher die Annahme des Angebots erklärt wird und in der die Bestelldaten des
    Kunden nochmals detailliert aufgeführt werden. Der Anbieter ist nicht zur
    Annahme des Angebotes verpflichtet. Der Anbieter kann ohne Angabe von Gründen
    das Kaufangebot ablehnen. </span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>Der
    Kunde kann über die Funktion „Drucken“ die Auftragsbestätigung ausdrucken. Ist
    nach drei Bankarbeitstagen nach Versand der Auftragsbestätigung kein Zahlungseingang
    beim Anbieter festzustellen, hat der Anbieter das Recht vom Kaufvertrag zurückzutreten.
    Der Kunde muss dann erneut bestellen. Nach Eingang der Bezahlung auf dem Konto
    des Anbieters erhält der Kunde eine Versandbestätigung bzw. die Bestätigung über
    die Einlagerung der Waren per E-Mail. In der E-Mail zur Einlagerungsbestätigung
    wird dem Kunden die genaue Bezeichnung der verwahrten physischen Waren und eine
    Aufstellung der Kosten für das erste Einlagerungsquartal mitgeteilt.&nbsp;</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><b><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>§
    3 Vertragsschluss Sparplan Benutzerkonto, </span></b></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(1)
    Der Kunde hat die Möglichkeit einen Sparplan abzuschließen. Beim
    Online-Vertragsschluss gibt der Kunde ein verbindliches Angebot auf Abschluss
    des Sparvertrags ab, indem der Kunde nach vollständiger Eingabe und ggf. Korrektur
    der Daten den entsprechenden Button („Sparplan jetzt abschließen“) anklickt
    (Antrag). Den Zugang des Antrags bestätigt der Anbieter per E-Mail
    (Eingangsbestätigung). Nach Prüfung der Angaben des Kunden  informiert der
    Anbieter den Kunden in der Regel am folgenden Werktag per E-Mail über die
    Annahme des Antrags (Auftragsbestätigung), wodurch der Vertrag nach Maßgabe der
    Sparplanbedingungen verbindlich zustande kommt. Entsprechendes gilt bei
    telefonischem und postalischem Vertragsschluss. Der Anbieter behält sich das
    Recht vor, Anträge ohne Angabe von Gründen abzulehnen. In allen Fällen erhalten
    Sie spätestens nach durchgeführter Legitimationsprüfung eine von uns
    unterschriebene Vertragsbestätigung mit den geltenden Sparplanbedingungen
    ausgehändigt oder per Post zugesandt.</span></p>

    <p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span
    lang=DE style='font-family:"Times New Roman",serif'>Beim Erwerb von
    Edelmetallen über einen Sparplan , kauft der Kunde in regelmäßigen Abständen
    (z.B. jeden Monat) Anteile von angebotenen Sparplanprodukten für einen festen
    Betrag (z.B. 100 EUR) . Der Mindestkaufbetrag beträgt 50,00 EUR monatlich. </span></p>

    <p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span
    lang=DE style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>Die
    Anteile werden mit bis zu fünf Nachkommastellen gerechnet und jeweils
    abgerundet. Zusätzliche Käufe (Einmalkäufe für z.B. 5.000 EUR) sind weiterhin möglich.
    Entscheidet sich der Kunde für den Abschluss eines Sparplanes, so muss sich der
    Kunde registrieren und unter anderem ein Referenzkonto Bank angeben. Mit der
    Registrierung erhält der Kunde ein Kundenkonto. Bei jedem Kauf eines weiteren
    Anteils bekommt der Kunde eine Abrechnung per E-Mail übersandt. Für jeden
    einzelnen Kauf eines weiteren Anteils gelten die Regelungen dieser AGB wie für
    einen Einzelkauf (z.B. Preise für jeden einzelnen Kauf, Aufhebungsrecht bei
    nicht marktgerechten Preisen, jederzeitige Verkaufsmöglichkeit).</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'><br>
    </span><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(2)
    Der Sparvertrag kann sowohl Vorort bei DPI als auch im Fernabsatz, d.h. je nach
    Angebot postalisch, telefonisch oder online über unsere Website abgeschlossen
    werden. In allen Fällen des Online-Vertragsschlusses muss der Kunde sich unter
    Angabe von vollständigen und wahrheitsgemäßen Daten zunächst als Kunde
    registrieren und dabei ein Passwort festlegen. Einzelheiten hierzu sind in den
    Deutsche Premium Investment Benutzerkonto-Bedingungen geregelt.</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(3)
    Die Bestände des Kunden werden in den Räumlichkeiten des Einlagerungspartners
    vom Anbieter aufbewahrt. Der Kunde schließt zu diesem Zweck einen
    kostenpflichtigen Verwahrungsvertrag nach den Bestimmungen dieser AGB ab. Der
    Kunde bleibt jederzeit Eigentümer der Edelmetalle. Die Edelmetalle werden in
    separaten, vom Eigentum und Besitz des Anbieters getrennten Boxen aufbewahrt.
    Die Aufbewahrung kann in einer Sammelverwahrung zusammen mit anderen Kundenbeständen
    erfolgen. Der Anbieter stellt sicher, dass die Edelmetallbestände der Kunden
    immer durch das entsprechende Metallgewicht im jeweiligen Edelmetall hinterlegt
    sind. Ein Zutrittsrecht zu den Verwahrräumlichkeiten des Anbieters oder des
    Einlagerungspartners besteht nicht. Die Gebühren für die Verwahrung können auf
    der online Seite des Anbieters jederzeit eingesehen werden. </span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>Die
    Gebühr für die Verwahrung ist nach unten durch einen Mindestbetrag begrenzt.
    Der Mindestbetrag und der Prozentsatz werden auf der Webseite des Anbieters
    aktuell angegeben. Die Gebühren werden zu Beginn des Einlagerungsquartals vom
    Edelmetallbestand des Kunden abgezogen. </span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(4)
    Der Kunde hat die Möglichkeit über einen personalisierten Zugang, seine
    Metallbestände zu verwalten. Der Anbieter übersendet dem Kunden auf Anfrage
    einen Bericht über die eingelagerten Metalle. Der Bericht enthält unter anderem
    Angaben über den Bestand der Edelmetalle. In jedem Fall erhält der Kunde nach
    Ablauf eines Kalenderjahres (jeweils bis Ende Januar des Folgejahres) einen
    Jahres-Kontoauszug als Rechnungsabschluss übersandt. Einwendungen wegen
    Unrichtigkeit oder Unvollständigkeit des Abschlusses sind innerhalb von sechs
    Wochen nach dessen Zugang zu erheben. Das Unterlassen rechtzeitiger
    Einwendungen gilt als Genehmigung.</span></p>

    <p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
    15.0pt;margin-left:0in;text-align:justify;text-justify:inter-ideograph;
    line-height:24.0pt'><b><span lang=DE style='font-family:"Times New Roman",serif'>§
    4 Identitätsfeststellung /Legitimationsprüfung</span></b></p>

    <p class=MsoNormal style='margin-top:5.0pt;margin-right:0in;margin-bottom:5.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph'><span lang=DE
    style='font-family:"Times New Roman",serif'>(1) Der Anbieter hat jederzeit das
    Recht, über ein von ihm vorgeschlagenes Identifizierungsverfahren, z.B.
    Postident, die Identität des Kunden zweifelsfrei feststellen zu lassen, z.B.
    bei Vertragsschluss, im Falle des Verkaufs von Ware aus der Verwahrung, wenn
    der Kontoinhaber des Referenzkontos nicht mit dem Kunden identisch ist.
    Verweigert sich der Kunde der Identitätsfeststellung oder konnte die Identität
    nicht zweifelsfrei festgestellt werden, so ist der Anbieter zum Rücktritt vom
    Vertrag berechtigt, etwaige Verkaufs- oder Ankaufsorder werden storniert. Im
    Falle einer stornierten Ankaufsorder verbleibt die Ware des Kunden beim
    Anbieter, bis der Kunde sich nach den Vorgaben des Anbieters identifiziert hat.
    Die Kosten des Rücktritts, wie auch der fortgesetzten Verwahrung sind in diesem
    Fall vom Kunden zu tragen.</span><span lang=DE style='font-family:"Times New Roman",serif;
    color:#343434'><br>
    <br>
    </span></p>

    <p class=MsoNormal style='margin-top:5.0pt;margin-right:0in;margin-bottom:5.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph'><b><span
    lang=DE style='font-family:"Times New Roman",serif'>§ 5 Eigentumsvorbehalt</span></b></p>

    <p class=MsoNormal style='margin-top:5.0pt;margin-right:0in;margin-bottom:5.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph'><span lang=DE
    style='font-family:"Times New Roman",serif'>Der Kaufgegenstand bleibt bis zur
    vollständigen Bezahlung Eigentum des Anbieters. Vor Eigentumsübertragung ist
    eine Verpfändung, Sicherungsübereignung, Verarbeitung oder Umgestaltung ohne
    ausdrückliche Einwilligung des Anbieters nicht zulässig.</span></p>

    <p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
    15.0pt;margin-left:0in;text-align:justify;text-justify:inter-ideograph;
    line-height:24.0pt'><b><span lang=DE style='font-family:"Times New Roman",serif'>§
    6 Zahlungsmodalitäten</span></b></p>

    <p class=MsoNormal style='margin-top:5.0pt;margin-right:0in;margin-bottom:5.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph'><span lang=DE
    style='font-family:"Times New Roman",serif'>(1) Der Kunde wird die Zahlung per Überweisung
    vornehmen.</span></p>

    <p class=MsoNormal style='margin-top:5.0pt;margin-right:0in;margin-bottom:5.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph'><span lang=DE
    style='font-family:"Times New Roman",serif'>(2) Die Zahlung des Kaufpreises ist
    mit Vertragsschluss fällig. Ist die Fälligkeit der Zahlung nach dem Kalender
    bestimmt, so kommt der Kunde bereits durch Versäumung des Termins in Verzug. In
    diesem Fall hat er dem Anbieter Verzugszinsen in Höhe von 5 Prozentpunkten über
    dem Basiszinssatz zu zahlen.</span></p>

    <p class=MsoNormal style='margin-top:5.0pt;margin-right:0in;margin-bottom:5.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph'><span lang=DE
    style='font-family:"Times New Roman",serif'>(3) Die Verpflichtung des Kunden
    zur Zahlung von Verzugszinsen schließt die Geltendmachung weiterer Verzugsschäden
    durch den Anbieter nicht aus.</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;line-height:15.0pt'><b><span lang=DE style='font-family:"Times New Roman",serif;
    color:#343434'>§ 7 Widerrufsrecht</span></b><b><span lang=DE style='font-family:
    "Times New Roman",serif;color:#343434'><br>
    </span></b><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(1)
    Wenn Sie Verbraucher sind, k</span><span lang=SV style='font-family:"Times New Roman",serif;
    color:#343434'>ö</span><span lang=DE style='font-family:"Times New Roman",serif;
    color:#343434'>nnen Sie den Abschluss des Sparvertrages aufgrund gesetzlicher
    Vorschriften innerhalb von 14 Tagen ab Vertragsschluss widerrufen. Hierüber
    informieren wir Sie nach Maßgabe der gesetzlichen Muster nachfolgend. </span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><i><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>WIDERRUFSBELEHRUNG</span></i><span
    lang=DE style='font-family:"Times New Roman",serif;color:#343434'><br>
    </span><i><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>Widerrufsrecht</span></i><span
    lang=DE style='font-family:"Times New Roman",serif;color:#343434'><br>
    </span><i><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>Sie
    haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag
    zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des
    Vertragsschlusses. Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (</span></i><span
    lang=DE style='font-family:"Times New Roman",serif;color:#343434'>Deutsche
    Premium Investment</span><i><span lang=DE style='font-family:"Times New Roman",serif;
    color:#343434'> – </span></i><i><span lang=DA style='font-family:"Times New Roman",serif;
    color:#343434'>DPI Goldsparplan </span></i><i><span lang=DE style='font-family:
    "Times New Roman",serif;color:#343434'>–, Paffrather Str. 315, 51469 Bergisch
    Gladbach, E-Mail: info@dpigold.com, Telefon: +49 2202 2512311/12) mittels einer
    eindeutigen Erklärung (z. B. ein mit der Post versandter Brief, Telefax oder
    E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie k</span></i><i><span
    lang=SV style='font-family:"Times New Roman",serif;color:#343434'>ö</span></i><i><span
    lang=DE style='font-family:"Times New Roman",serif;color:#343434'>nnen dafür
    das beigefügte Muster-Widerrufsformularverwenden, das jedoch nicht
    vorgeschrieben ist. Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die
    Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist
    absenden.</span></i><span lang=DE style='font-family:"Times New Roman",serif;
    color:#343434'><br>
    <br>
    </span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;line-height:15.0pt'><i><span lang=DE style='font-family:"Times New Roman",serif;
    color:#343434'>Folgen des Widerrufs</span></i><span lang=DE style='font-family:
    "Times New Roman",serif;color:#343434'><br>
    </span><i><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>Wenn
    Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von
    Ihnen erhalten haben, unverzüglich und spätestens binnen vierzehn Tagen ab dem
    Tag zurückzuzahlen, indem die Mitteilung über Ihren Widerruf dieses Vertrages
    bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe
    Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es
    sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall
    werden Ihnen wegen dieser Rückzahlung Entgelte berechnet. Haben Sie verlangt,
    dass die Dienstleistungen während der Widerrufsfrist beginnen sollen, so haben
    Sie uns einen angemessenen Betrag zu zahlen, der dem Anteil der bis zu dem
    Zeitpunkt, zu dem Sie uns von der Ausübung des Widerrufsrechts hinsichtlich
    dieses Vertrags unterrichten, bereits erbrachten Dienstleistungen im Vergleich
    zum Gesamtumfang der im Vertrag vorgesehenen Dienstleistungen entspricht. </span></i></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><i><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>Klarstellende
    Ergänzung zur gesetzlichen Widerrufsbelehrung </span></i></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><i><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>Bitte
    beachten Sie, dass wir aus operativen Gründen jede Einzahlung auf unsere
    Sparplankonten als Verlangen zum vertragsgemäßen Beginn unserer
    Dienstleistungen durch sofortige Konvertierung und Gutschrift auf Ihrem
    Kundenkontowerten müssen. Der uns im Falle eines fristgerechten Widerrufs von
    Ihnen für die bereits begonnene Dienstleistung zuzahlende angemessene Entschädigungsbetrag
    besteht daher in dem seit der Konvertierung Ihrer Einzahlung bis zum Widerruf
    ggf. eingetretenen Kursverlust. Weitere Entschädigungen verlangen wir nicht.
    Kursgewinne werden nicht ausbezahlt. Ihr Kündigungsrecht bleibt unberührt. </span></i></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><i><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(2)
    Über das Muster-Widerrufsformular bei Fernabsatzverträgen informieren wir nach
    der gesetzlichen Regelung wie folgt:</span></i><span lang=DE style='font-family:
    "Times New Roman",serif;color:#343434'><br>
    </span><i><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>Muster-Widerrufsformular
    (Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular
    aus, und senden Sie es zurück.) </span></i></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><i><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>-
    An: </span></i><span lang=DE style='font-family:"Times New Roman",serif;
    color:#343434'>Deutsche Premium Investment</span><i><span lang=DE
    style='font-family:"Times New Roman",serif;color:#343434'> – </span></i><i><span
    lang=DA style='font-family:"Times New Roman",serif;color:#343434'>DPI
    Goldsparplan </span></i><i><span lang=DE style='font-family:"Times New Roman",serif;
    color:#343434'>–, Paffrather Str. 315, 51469 Bergisch Gladbach, E-Mail: ***,
    Fax: +49 ***, Telefon: +49 ***</span></i><span lang=DE style='font-family:"Times New Roman",serif;
    color:#343434'><br>
    </span><i><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>-
    Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über
    den Kauf der folgenden Waren (*) /die Erbringung der folgenden Dienstleistung
    (*) </span></i></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><i><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>-
    Bestellt am (*) /erhalten am (*) __________________________</span></i><span
    lang=DE style='font-family:"Times New Roman",serif;color:#343434'><br>
    </span><i><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>-
    Name des/der Verbraucher(s) __________________________</span></i><span lang=DE
    style='font-family:"Times New Roman",serif;color:#343434'><br>
    </span><i><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>-
    Anschrift des/der Verbraucher(s) _______________________</span></i><span
    lang=DE style='font-family:"Times New Roman",serif;color:#343434'><br>
    </span><i><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>-
    Unterschrift des/der Verbraucher(s) _____________________ (nur bei Mitteilung
    auf Papier) - Datum ______________________ </span></i></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><i><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(*)
    Unzutreffendes streichen </span></i></p>

    <p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
    15.0pt;margin-left:0in;text-align:justify;text-justify:inter-ideograph;
    line-height:24.0pt'><b><span lang=DE style='font-family:"Times New Roman",serif'>&nbsp;</span></b></p>

    <p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
    15.0pt;margin-left:0in;text-align:justify;text-justify:inter-ideograph;
    line-height:24.0pt'><b><span lang=DE style='font-family:"Times New Roman",serif'>§
    8 NICHTBESTEHEN DES WIDERRUFSRECHTS</span></b></p>

    <p class=MsoNormal style='margin-top:5.0pt;margin-right:0in;margin-bottom:5.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph'><b><u><span
    lang=DE style='font-family:"Times New Roman",serif'>Soweit es sich um einen
    Vertrag zur Lieferung von Ware handelt, deren Preis von Schwankungen auf dem
    Finanzmarkt abhängt (alle Edelmetallprodukte), auf die der Unternehmer keinen
    Einfluss hat und die innerhalb der Widerrufsfrist auftreten können, besteht gemäß
    § 312g Abs. 2 Nr. 8 BGB kein Widerrufsrecht.</span></u></b></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><b><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>§
    9 Verfügungsbefugnis, Vollmacht, Kundenmehrheit, Rechtsnachfolge </span></b></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(1)
    Vorbehaltlich anderweitiger Vereinbarungen und rechtswirksam erteilter
    Vollmachten gilt nur der bei uns registrierte Kunde bzw. dessen gesetzliche(r)
    Vertreter als verfügungsberechtigter Miteigentümer. Die Verfügungsbefugnis
    umfasst das Recht, sämtliche rechtserhebliche Erklärungen in Bezug auf den
    Sparvertrag abzugeben und entgegenzunehmen sowie physische Bestände in Empfang
    zu nehmen. Soweit sich aus einer im Original vorgelegten Vollmachtsurkunde
    nichts anderes ergibt, gilt diese über den Tod des Kunden hinaus.</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(2)
    Vorbehaltlich anderweitiger Vereinbarungen muss sich die jeweils handelnde
    Person bei jeder Verfügung identifizieren und, sofern sie nicht selbst Kunde
    ist, als für den Kunden vertretungsberechtigt legitimieren. </span></p>

    <p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
    15.0pt;margin-left:0in;text-align:justify;text-justify:inter-ideograph;
    line-height:24.0pt'><span lang=DE style='font-family:"Times New Roman",serif;
    color:#343434'> (3) Sind mehrere Personen (z. B. Ehegatten, Lebenspartner)
    gemeinsam Kunden des Sparvertrags und ist nicht ausnahmsweise eine
    gemeinschaftliche Verfügungsbefugnis individuell vereinbart („und“-Sparplan),
    sind sie jeweils einzeln und ohne Mitwirkung des anderen über den Sparplan verfügungsbefugt
    („oder“-Sparplan). Die Einzelverfügungsbefugnis berechtigt nicht zu Kündigungen,
    Vertragsänderungen und Erteilung von Vollmachten. Wenn ein Kunde die Einzelverfügungsbefugnis
    uns gegenüberschriftlich widerruft, entsteht ein „und“-Sparplan, und es kann
    nur noch gemeinschaftlich unter Mitwirkung aller Kunden verfügt werden. Das
    Widerrufsrecht steht auch den Erben eines von mehreren Kunden – jedem für sich
    alleine – zu. Zur Empfangnahme unserer Erklärungen gelten auch beim „und“-Sparplan
    alle Kunden als wechselseitig bevollmächtigt</span></p>

    <p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
    15.0pt;margin-left:0in;text-align:justify;text-justify:inter-ideograph;
    line-height:24.0pt'><b><span lang=DE style='font-family:"Times New Roman",serif'>§
    10 Sachmängelgewährleistung, Garantie</span></b></p>

    <p class=MsoNormal style='margin-top:5.0pt;margin-right:0in;margin-bottom:5.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph'><span lang=DE
    style='font-family:"Times New Roman",serif'>(1) Der Anbieter haftet für Sachmängel
    gegenüber Verbrauchern nach den hierfür geltenden gesetzlichen Vorschriften,
    insbesondere §§ 434 ff BGB. Der Kunde hat jedoch offensichtliche Mängel mit
    einer Frist von einem Monat dem Anbieter schriftlich (per E-Mail ist
    ausreichend) mitzuteilen, da andernfalls seine Mängelansprüche ausgeschlossen
    sind.</span></p>

    <p class=MsoNormal style='margin-top:5.0pt;margin-right:0in;margin-bottom:5.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph'><span lang=DE
    style='font-family:"Times New Roman",serif'>(2) Ist der Kauf für den Anbieter
    und den Kunden ein Handelsgeschäft, hat der Kunde die gelieferte Ware unverzüglich
    auf Qualitäts- und Mengenabweichung zu untersuchen und dem Anbieter erkennbare
    Mängel unverzüglich schriftlich anzuzeigen; andernfalls ist die Geltendmachung
    des Gewährleistungsanspruchs ausgeschlossen. Verdeckte Mängel sind dem Anbieter
    innerhalb einer Frist von einer Woche ab Entdeckung schriftlich anzuzeigen. Zur
    Fristwahrung genügt die rechtzeitige Absendung. Den Kunden trifft in diesem
    Fall die volle Beweislast für sämtliche Anspruchsvoraussetzungen, insbesondere
    für den Mangel selbst, für den Zeitpunkt der Feststellung des Mangels und für
    die Rechtzeitigkeit der Mängelrüge.</span></p>

    <p class=MsoNormal style='margin-top:5.0pt;margin-right:0in;margin-bottom:5.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph'><span lang=DE
    style='font-family:"Times New Roman",serif'>Bei Mängeln leistet der Anbieter
    nach eigener Wahl Gewähr durch Nachbesserung oder Ersatzlieferung.</span></p>

    <p class=MsoNormal style='margin-top:5.0pt;margin-right:0in;margin-bottom:5.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph'><b><span
    lang=DE style='font-family:"Times New Roman",serif'>Die Ansprüche des Kunden
    wegen Mängeln verjähren in einem Jahr. Diese Verjährungsfrist gilt nicht für Schadensersatzansprüche.</span></b></p>

    <p class=MsoNormal style='margin-top:5.0pt;margin-right:0in;margin-bottom:5.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph'><span lang=DE
    style='font-family:"Times New Roman",serif'>(3) Eine Garantie besteht bei den
    vom Anbieter gelieferten Waren nur, wenn diese ausdrücklich in der Auftragsbestätigung
    zu dem jeweiligen Artikel abgegeben wurde.</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><b><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>§
    11 Haftungsbeschränkung</span></b></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(1)
    Für andere als durch Verletzung von Leben, Körper und Gesundheit entstehende
    Schäden haftet der Anbieter nur, soweit diese Schäden auf vorsätzlichem oder
    grob fahrlässigem Handeln oder auf schuldhafter Verletzung einer wesentlichen
    Vertragspflicht durch den Anbieter oder deren Erfüllungsgehilfen beruhen.
    Vertragswesentlich ist eine Pflicht, deren Erfüllung die ordnungsgemäße Durchführung
    des Vertrages überhaupt erst ermöglicht und auf deren Einhaltung der Kunde
    regelmäßig vertrauen darf. Eine darüberhinausgehende Haftung auf Schadensersatz
    ist ausgeschlossen. Ansprüche aus einer vom Anbieter gegebenen Garantie für die
    Beschaffenheit des Kaufgegenstands und dem Produkthaftungsgesetz bleiben
    hiervon unberührt.</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(2)
    Haftet der Anbieter aus dem Verwahrungsvertrag, so ist ausschließliche
    Grundlage für die Wertermittlung im ersten Einlagerungsquartal der Wert des
    Ankaufspreises zum Zeitpunkt der Bestellung der Ware. Liegt der Haftungsgrund
    nicht im ersten Einlagerungsquartal, so ist Grundlage der Wertermittlung der
    Ankaufspreis zu Beginn, 0.00 Uhr, des jeweiligen Einlagerungsquartals.</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(3)
    Der Anbieter haftet nicht für Verluste oder Schäden, die durch folgende
    Ereignisse verursacht werden:</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:.5in;text-align:justify;text-justify:inter-ideograph;text-indent:
    -.25in;line-height:15.0pt'><span lang=DE style='font-size:10.0pt;font-family:
    Symbol;color:#343434'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span lang=DE style='font-family:"Times New Roman",serif;
    color:#343434'>ionisierende Strahlung, Radioaktivität oder Ereignisse mit ähnlich
    kontaminierender Wirkung gleich aus welcher Quelle;</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:.5in;text-align:justify;text-justify:inter-ideograph;text-indent:
    -.25in;line-height:15.0pt'><span lang=DE style='font-size:10.0pt;font-family:
    Symbol;color:#343434'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span lang=DE style='font-family:"Times New Roman",serif;
    color:#343434'>Angriffs- oder Verteidigungskriege, kriegerische Handlungen,
    ohne dass ein Krieg erklärt worden ist, Bürgerkrieg, Revolution, Aufstände,
    Verstaatlichung oder Beschlagnahme, Beschädigung oder Zerstörung durch
    staatliches Eingreifen, Terrorismus.</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(4)
    Nach dem jetzigen Stand der Technik kann die Datenkommunikation über das
    Internet nicht fehlerfrei und/oder jederzeit verfügbar gewährleistet werden.
    Der Anbieter haftet daher nicht für die jederzeitige Verfügbarkeit des Internetshops.</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><b><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>§
    12 Kündigung, Beendigung, Aufhebung des Miteigentums</span></b><b><span
    lang=DE style='font-family:"Times New Roman",serif;color:#343434'><br>
    </span></b><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(1)
    Der Sparvertrag wird auf unbestimmte Zeit geschlossen. Er kann von Ihnen und
    von uns jederzeit täglich gekündigt und aufgel</span><span lang=SV
    style='font-family:"Times New Roman",serif;color:#343434'>ö</span><span
    lang=DE style='font-family:"Times New Roman",serif;color:#343434'>st werden.
    Das beiderseitige Recht zur außerordentlichen Kündigung aus wichtigem Grund
    bleibt unberührt.</span><span lang=DE style='font-family:"Times New Roman",serif;
    color:#343434'><br>
    </span><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(2)
    Die Kündigung hat schriftlich zu erfolgen. Die Kündigung sollte die von Ihnen
    gewünschte Aufhebungsvariante bezeichnen, die individuell mit dem Kunden
    abgestimmt wird. In Zweifelsfällen behalten wir uns vor, von Ihnen eine
    nochmalige (mündliche oder schriftliche) Bestätigung der Kündigung und/oder der
    Aufhebungsvariante zu Legitimationszwecken zu verlangen.</span><span lang=DE
    style='font-family:"Times New Roman",serif;color:#343434'><br>
    </span><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(3)
    Wird der Vertrag durch Kündigung oder in anderer Weise beendet, k</span><span
    lang=SV style='font-family:"Times New Roman",serif;color:#343434'>ö</span><span
    lang=DE style='font-family:"Times New Roman",serif;color:#343434'>nnen Sie
    Ihren Anspruch auf Aufhebung des Miteigentums durch Verkauf Ihres Anteils an
    uns zum jeweiligen Goldsparplan-DPI Referenzpreis (Ankaufskurs) und
    entsprechende Überweisung an Sie (Auszahlung) geltend machen. Beim
    Wertlagersparen und beim Goldabonnement verwenden wir für die Auszahlung des
    Verkaufserl</span><span lang=SV style='font-family:"Times New Roman",serif;
    color:#343434'>ö</span><span lang=DE style='font-family:"Times New Roman",serif;
    color:#343434'>ses grundsätzlich das Bankkonto, von dem Sie uns Ihre regelmäßigen
    Sparraten überwiesen haben. Beim Goldsparen kann der Anspruch auf Aufhebung des
    Miteigentums auch durch die Auslagerung und Auslieferung ganzer Stücke 1 kg DPI
    Goldbarren aus dem Sammellagergeltend gemacht werden (siehe § 6 Abs. 4).
    Auslieferungen erfolgen an eine Lieferadresse in Deutschland (Festland) oder an
    eine unserer Niederlassungen zur Selbstabholung gegen Bezahlung der hiermit verbundenen
    Kosten. Verbleibende Differenzbeträge werden in EUR ausbezahlt bzw. mit
    anfallenden Kosten verrechnet. Bei jeder Auslieferung erfolgt eine
    Legitimationsprüfung der Empfangsperson gemäß § 2 Abs. 1, § 2 Abs. 3. Beim
    Goldsparen werden anteilige Lagergebühren mit Ihrem Guthaben verrechnet
    oderseparat eingezogen. Unser gesetzliches Pfandrecht am
    Miteigentumsanteilbleibt bis zur Befriedigung aller Forderungen aus dem Vertrag
    unberührt.</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><b><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>§
    13 Aufrechnung- und Zurückbehaltungsrechte</span></b></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>Aufrechnungs-
    und Zurückbehaltungsrechte sowie die Einrede des nicht erfüllten Vertrages
    stehen dem Anbieter in gesetzlichem Umfang zu. Ist der Kunde kein Verbraucher,
    steht ihm ein Aufrechnungs- oder Zurückbehaltungsrecht nur wegen rechtskräftig
    festgestellter oder unbestrittener Gegenforderungen zu.</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;line-height:15.0pt'><b><span lang=DE style='font-family:"Times New Roman",serif;
    color:#343434'>§ 1</span></b><b><span lang=DA style='font-family:"Times New Roman",serif;
    color:#343434'>4 Grundlage der Goldsparpl</span></b><b><span lang=DE
    style='font-family:"Times New Roman",serif;color:#343434'>äne, Sparbetrag,
    Einzahlungen</span></b><b><span lang=DE style='font-family:"Times New Roman",serif;
    color:#343434'><br>
    </span></b><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(1)
    Gemeinsame Grundlage der Deutsche Premium Investment  Goldsparpläne unter der
    Marke DPI in den von uns angebotenen Varianten (Goldsparen, Wertlagersparen und
    Goldabonnement) ist der Verkauf der dem eingezahlten Sparbetrag entsprechenden
    Menge bzw. Bruchteils Feingold an Sie (Konvertierung) und dementsprechende
    Verschaffung anteiligen Miteigentums in Sammelverwahrung (Gutschrift auf Ihrem
    Kundenkonto).</span><span lang=DE style='font-family:"Times New Roman",serif;
    color:#343434'><br>
    </span><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(2)
    Die monatlichen Sparbeträge sind per Überweisung (vorzugsweise Dauerauftrag)
    unter Angabe des Kunden (Nachname, Vorname) und der individuellen Kundennummer
    im Verwendungszweck auf das für den jeweiligen Sparplan geführte Konto der
    Deutsche Premium Investment zu überweisen. Kundennummer und
    Kontoverbindungwerden Ihnen zusammen mit der Annahme Ihres Antrags bzw. unserer
    schriftlichen Vertragsbestätigung per Post mitgeteilt. </span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(3)
    Neben dem monatlich festen Sparbetrag sind jederzeit flexible Einzahlungen
    (auch seitens Dritter) ausschließlich auf das benannte Konto unter unbedingter
    Angabe vorstehenden Verwendungszwecks m</span><span lang=SV style='font-family:
    "Times New Roman",serif;color:#343434'>ö</span><span lang=DE style='font-family:
    "Times New Roman",serif;color:#343434'>glich. Andernfalls k</span><span
    lang=SV style='font-family:"Times New Roman",serif;color:#343434'>ö</span><span
    lang=DE style='font-family:"Times New Roman",serif;color:#343434'>nnen wir
    Einzahlungen nicht zuverlässig zuordnen und die Verbuchung auf Ihren Sparplan
    nicht oder nicht fristgerecht ausführen. In solchen Fällen behalten wir uns
    eine Rücküberweisung auf das Zahlungskonto vor.</span><span lang=DE
    style='font-family:"Times New Roman",serif;color:#343434'><br>
    </span><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(4)
    Sind an einem Handelstag aus einem wichtigen, von der DPI nicht zu vertretenden
    Grund (insbesondere Aussetzung des Edelmetallhandels) keine Käufe m</span><span
    lang=SV style='font-family:"Times New Roman",serif;color:#343434'>ö</span><span
    lang=DE style='font-family:"Times New Roman",serif;color:#343434'>glich, sind
    wir dazu berechtigt, die Käufe erst am nächstm</span><span lang=SV
    style='font-family:"Times New Roman",serif;color:#343434'>ö</span><span
    lang=DE style='font-family:"Times New Roman",serif;color:#343434'>glichen
    Handelstag auszuführen. </span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in'><b><span lang=DE style='font-family:"Times New Roman",serif;
    color:#343434'>§ 15 Grundsätze der Sammellagerung, Miteigentümergemeinschaft,
    Kosten</span></b><b><span lang=DE style='font-family:"Times New Roman",serif;
    color:#343434'><br>
    </span></b><span lang=DE style='font-family:"Times New Roman",serif;color:#343434'>(1)
    Wir unterhalten für jede Sparplan-Variante ein eigenes Sammellager, in welches
    die jeweiligen Geldeingänge eines Handelstages zum DPI Referenzpreis
    (Verkaufskurs) – für jeden Kunden entsprechend der H</span><span lang=SV
    style='font-family:"Times New Roman",serif;color:#343434'>ö</span><span
    lang=DE style='font-family:"Times New Roman",serif;color:#343434'>he seiner
    Einzahlung – konvertiert und seinem pers</span><span lang=SV style='color:#343434'>ö</span><span lang=DE style='color:#343434'>nlichen Kundenkonto gutgeschrieben wird.
    Spätestens am Folgetag der Gutschrift erfolgt die physische Verbringung der
    seitens aller Kunden erworbenen Goldbestä</span><span lang=DA style='color:#343434'>nde indes f</span><span lang=DE
    style='color:#343434'>ür jeden Sparplan
    gesondert geführte und entsprechend bezeichnete Sammellager. Alle Sammelbestände
    sind jederzeit physisch voll gedeckt, gegebenenfalls durch Überlagerung mit
    Goldbeständen, die in unserem (Mit-)Eigentum stehen. Sie als Käufer/Einlagerer
    und wir als Verkäufer/Lagerhalter erklären bereits mit Abschluss des Vertrages
    die zum Eigentumsübergang auf Sie in H</span><span lang=SV style='color:#343434'>ö</span><span lang=DE style='color:#343434'>he des jeweils erworbenen
    Miteigentumsanteils erforderliche Einigung. Auf den Zugang einer gesonderten
    Annahmeerklärung wird wechselseitig verzichtet.</span><span lang=DE
    style='color:#343434'><br>
    </span><span lang=DE style='color:#343434'>(2)
    Sie erklären sich als Einlagerer bei Abschluss des Vertrages ausdrücklich mit der
    Sammellagerung, d.h. mit der Vermischung der eingelagerten Gegenstände gleicher
    Art und Güte im Sammellager des jeweiligen Sparplans, einverstanden, um die
    Entstehung von Miteigentum vom Zeitpunkt der Einlagerung ab und eine anteilige
    Auslieferung an jeden Miteigentümer zu erm</span><span lang=SV
    style='color:#343434'>ö</span><span
    lang=DE style='color:#343434'>glichen (§ 469
    HGB). Die gesetzlichen Regelungen über die Miteigentümergemeinschaft (§§ 742ff
    BGB) werden nach Maßgabe von § 469 HGB und diesen Sparplanbedingungen – auch
    mit Wirkung gegenüber Sondernachfolgern – abgeändert. Die Modalitäten der
    Aufhebung des Miteigentums während der Laufzeit desjeweiligen Sparplans sind in
    § 6 bis § 8 und bei Beendigung des Vertrags in § 11 geregelt. In jedem Fall
    sind wir als Lagerhalter zur Durchführung einer der jeweiligen Größe der
    Miteigentumsanteile entsprechenden Teilung ermächtigt</span><span lang=DE
    style='color:#343434'><br>
    </span><span lang=DE style='color:#343434'>(3)
    Wir behalten uns vor, Auslieferungen nicht aus dem betreffenden Sammellager,
    sondern durch Übereignung gleichartiger Stücke aus anderen Goldbeständen zu erfüllen.
    In diesem Fall geht der entsprechende Miteigentumsanteil am Sammelbestandmit
    erfolgter Auslieferung auf uns über. Das Gleiche gilt im Falle von (Teil-)Verkäufen
    Ihres Goldbestands an uns mit Auszahlung (Überweisung) des Euro- Gegenwerts an
    Sie.</span><span lang=DE style='color:#343434'><br>
    </span><span lang=DE style='color:#343434'>(4)
    Die Sammellagerung erfolgt in von uns als Lagerhalter betriebenen und für die
    Einlagerung wertvoller Güter speziell ausgestatteten Räumlichkeiten in
    Deutschland. Es besteht jedoch kein Anspruch auf Verwahrung an einem bestimmten
    Ort. Alle Lagerbestände sind im branchenüblichen Umfang zum vollen Wert gegen
    Verlust und Beschädigung versichert.</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph'><span lang=DE
    style='color:#343434'>(5) Weitere Details
    des Sparvertrags einschließlich Modalitäten der Aufhebung der Miteigentümergemeinschaft
    während der Laufzeit des Sparplans Gebühren und Kosten sind für die jeweiligen
    Sparplä</span><span lang=NL style='
    color:#343434'>ne gem</span><span lang=DE style='
    color:#343434'>äß § 6 bis § 8 unterschiedlich geregelt. Wir sind berechtigt, fällige
    Zahlungen mittels eines durch Sie zu erteilenden SEPA-Lastschriftmandats
    einzuziehen oder Ihr Kundenkontomit dem entsprechenden Betrag (nach
    Konvertierung) zu belasten. </span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph'><span lang=DE
    >&nbsp;</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;line-height:15.0pt'><b><span lang=DE style='
    color:#343434'>§ 1</span></b><b><span lang=DA style='
    color:#343434'>6 Goldsparen</span></b><b><span lang=DE style='
    color:#343434'><br>
    </span></b><span lang=DE style='color:#343434'>(1)
    Beim DPI Goldsparen handelt es sich um eine flexible Goldanlage mit sicherer
    Sammellagerung. Mit monatlichen Sparbeträgen und ggf. flexiblen Einzahlungen
    (auch seitens Dritter) erwerben Sie kontinuierlich Miteigentumsanteile an
    Sammelbeständen bis zu 1 kg DPI Goldbarren. Eindeutig zuordenbare Geldeingänge
    bis *** Uhr werden taggleich zum jeweiligen DPI Referenzpreis (Verkaufskurs)
    der Produktkategorie „</span><span lang=DA style='
    color:#343434'>Goldsparen</span><span lang=DE style='
    color:#343434'>“ in die dem überwiesenen Betrag entsprechende Menge Feingold
    konvertiert und Ihrem Sparplankonto gutgeschrieben.</span><span lang=DE
    style='color:#343434'><br>
    </span><span lang=DE style='color:#343434'>(2)
    Vom Sparplanbestand sind handelstäglich Verkäufe an DPI in beliebiger H</span><span
    lang=SV style='color:#343434'>ö</span><span
    lang=DE style='color:#343434'>he m</span><span
    lang=SV style='color:#343434'>ö</span><span
    lang=DE style='color:#343434'>glich. Diese
    erfolgen zum jeweiligen DPI Referenzpreis (Ankaufskurs). Ihr Auslieferungsanspruch
    bei Vertragsende (§ 11 Abs. 3) bleibt hiervon unberührt. Für jegliche
    Auszahlungen verwenden wir grundsätzlich das von Ihnen bei Vertragsschluss
    angegebene Bankkonto, das bei einem innerhalb der EU ansässigen Kreditinstitut
    auf Sie bzw. den von Ihnen vertretenen minderjährigen Kunden als (Mit-)
    Kontoinhabergeführt wird (Referenzkonto). Das Referenzkonto kann auch ein
    Sparkonto sein.</span><span lang=DE style='
    color:#343434'><br>
    </span><span lang=DE style='color:#343434'>(3)
    Die Er</span><span lang=SV style='
    color:#343434'>ö</span><span lang=DE style='
    color:#343434'>ffnung des Kontos und die Kontoführung ist kostenfrei. Die H</span><span
    lang=SV style='color:#343434'>ö</span><span
    lang=DE style='color:#343434'>he und
    Berechnungsweise der Gebühren für Lagerung, Verkäufe/Auszahlungen und ggf.
    sonstige Transaktionen werden bei Vertragsschluss nach Maßgabe unserer jeweils
    gültigen Preise vereinbart. Lagergebühren werden quartalsweise für das
    vorangegangene Quartal zur Zahlung fällig und nach entsprechender
    Rechnungsstellung per Lastschrifteingezogen. Bei unterjähriger
    Vertragsbeendigung erfolgt die Abrechnung zeitanteilig und kann mit dem
    Aufhebungsguthabengemäß § 11 Abs. (3) verrechnet werden. Transaktionsgebührensind
    jeweils unmittelbar vor Durchführung der Transaktion im Voraus zur Zahlung fällig.
    (4) Ab einem Sparplanbestand von 1.000,00 Gramm kann die Auslagerung ganzer Stücke
    1 kg DPI Goldbarren aus dem Sammellager verlangt werden. Dafür fallen
    Auslagerungs- und Versandkostengemäß Wertlager-Preisliste an.</span><span
    lang=DE style='color:#343434'><br>
    <br>
    </span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;line-height:15.0pt'><b><span lang=DE style='
    color:#343434'>§ 17 Wertlagersparen</span></b><b><span lang=DE
    style='color:#343434'><br>
    </span></b><span lang=DE style='color:#343434'>(1)
    Beim DPI Wertlagersparen handelt es sich um Goldanlagen für konkrete Sparziele
    mit anschließender Wertlagerung. Als Sparziele sind bei Vertragsschluss
    folgende Produkte wählbar: </span><i><span lang=DE style='
    color:#343434'>1oz DPI Goldbarren, 1 oz Krügerrand Goldmünze oder 100 g DPI
    Goldbarren (gegossen).</span></i><span lang=DE style='
    color:#343434'><br>
    </span><span lang=DE style='color:#343434'>(2)
    Mit monatlichen Sparbeträgen und ggf. flexiblen Einzahlungen (auch seitens
    Dritter) erwerben Sie kontinuierlich Miteigentumsanteile an jeweils gesondert
    geführten Sammelbeständen Ihres gewählten Produkts. Eindeutig zuordenbare
    Geldeingänge bis 11:00 Uhr werden taggleich zum jeweiligen DPI Referenzpreis
    (Verkaufskurs) Wertlagersparen des gewählten Produkts in einen dem überwiesenen
    Sparbetrag entsprechenden Bruchteil eines ganzen Stücks (Sparziel) konvertiert
    (kleinste Einheit:0,0001) und Ihrem Sparplankonto gutgeschrieben.</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='color:#343434'>(3)
    Während der Sparphase fallen keine Gebühren an. Ab der Verwahrung Bei DPI
    Wertlager berechnen wir Gebühren und Kosten gemäß Preisliste zum
    Wertlagervertrag.</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;line-height:15.0pt'><span lang=DE style='
    color:#343434'><br>
    </span><b><span lang=DE style='color:#343434'>§
    1</span></b><b><span lang=FR style='
    color:#343434'>8 Goldabonnement</span></b><b><span lang=DE style='color:#343434'><br>
    </span></b><span lang=DE style='color:#343434'>(1)
    Beim DPI Goldabonnement handelt es sich um Goldanlagen für konkrete Sparziele
    mit anschließender Auslieferung. Als Sparziele sind bei Vertragsschluss
    folgende Produkte wählbar: </span><i><span lang=DE style='
    color:#343434'>1oz DPI Goldbarren, 1 oz Krügerrand Goldmünze oder 100 g DPI
    Goldbarren (gegossen). </span></i></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='color:#343434'>(2)
    Mit monatlichen Sparbeträgen und ggf. flexiblen Einzahlungen (auch seitens
    Dritter) erwerben Sie kontinuierlich Miteigentumsanteile an jeweils gesondert
    geführten Sammelbeständen Ihres gewählten Produkts. Eindeutig zuordenbare
    Geldeingänge bis 11:00 Uhr werden taggleich zum jeweiligen DPI Referenzpreis
    (Verkaufskurs) Goldabonnement des gewählten Produkts in einen dem überwiesenen
    Sparbetrag entsprechenden Bruchteil eines ganzen Stücks (Sparziel) konvertiert
    (kleinste Einheit:0,0001) und Ihrem Sparplankonto gutgeschrieben. </span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='color:#343434'>(3)
    Sobald ein Sparziel (z. B. 1 Stück 100 g DPI Goldbarren) erreicht ist, wird das
    entsprechende Stück dem Sammellager entnommen und entweder per Wertkurier direkt
    an Sie (Lieferadresse in Deutschland, Festland) ausgeliefert oder zur pers</span><span
    lang=SV style='color:#343434'>ö</span><span
    lang=DE style='color:#343434'>nlichen
    Abholung bei DPI bereitgestellt. In beiden Fällen erfolgt eine Legitimationsprüfung
    der Empfangsperson gemäß § 2 Abs. 1. Differenzbeträge verbleiben auf Ihrem
    Sparplankonto. Solange der Sparplan nicht gekündigt ist, läuft Ihr
    Goldabonnement zum Erwerb weiterer Sparziele des gewählten Produkts weiter. </span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='color:#343434'>(4)
    Während der Sparphase fallen keine Gebühren an. Die Kosten für die Auslieferung
    werden bei Vertragsschluss vereinbart, sind jeweils im Voraus zur Zahlung fällig
    und werden nach entsprechender Rechnungsstellung per Lastschrift eingezogen.</span><span
    lang=DE style='color:#343434'><br>
    <br>
    </span><b><span lang=DE >§ 19
    Schlussbestimmungen</span></b></p>

    <p class=MsoNormal style='margin-top:5.0pt;margin-right:0in;margin-bottom:5.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph'><span lang=DE
>(1) Ist der Kunde Kaufmann gilt für
    diese AGB und alle Rechtsbeziehungen zwischen dem Anbieter und dem Kunden
    ausschließlich das Recht der Bundesrepublik Deutschland unter Ausschluss aller
    internationalen und supranationalen (Vertrags-) Rechtsordnungen, insbesondere
    des UN-Kaufrechts. Voraussetzungen und Wirkungen des Eigentumsvorbehalts
    unterliegen dem Recht am jeweiligen Lagerort der Sache, soweit danach die
    getroffene Rechtswahl zugunsten des deutschen Rechts unzulässig oder unwirksam
    ist. Ist der Kunde Verbraucher gelten die gesetzlichen Vorschriften.</span></p>

    <p class=MsoNormal style='margin-top:5.0pt;margin-right:0in;margin-bottom:5.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph'><span lang=DE>(2) Sofern es sich beim Kunden um
    einen Kaufmann, eine juristische Person des öffentlichen Rechts oder um ein öffentlich-rechtliches
    Sondervermögen handelt, ist Gerichtsstand für alle Streitigkeiten aus
    Vertragsverhältnissen zwischen dem Kunden und dem Anbieter der Sitz des
    Anbieters.</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;text-align:justify;text-justify:inter-ideograph;line-height:
    15.0pt'><span lang=DE style='color:#343434'>&nbsp;</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;line-height:15.0pt'><span lang=DE style='font-size:13.5pt;
    color:#343434'>&nbsp;</span></p>

    <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
    margin-left:0in;line-height:15.0pt'><span lang=DE>&nbsp;</span></p>

    </div>
</mat-dialog-content>
